








import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ListViewItem from "./listviewitem";

@Component({
  name: "ui-list-view-item-check"
})
export default class UIListViewItemCheckComponent extends Vue {
  // параметры
  @Prop({ default: null, type: Object })
  item!: ListViewItem<any>;

  onSelect(value: any) {
    this.$emit("select", value);
  }
  // getSlot() {
  //   console.log("getSlot", this.$slots);
  //   return "hh";
  // }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/list-view/src/ui-list-view-item-check.vue